import ReactGA from 'react-ga';
const trackingId = "G-78V8563058";

const isDev = (process.env.REACT_APP_NODE_ENV === "local") || (process.env.REACT_APP_NODE_ENV === "development");

if( !isDev ) {
    ReactGA.initialize(trackingId);
}

export default ReactGA;
